const setLanguageSlovak = () => ({
  type: 'SET_SK',
})
const setLanguageEnglish = () => ({
  type: 'SET_EN',
})

export { setLanguageEnglish, setLanguageSlovak }
